import { smartMagazineSelector as smartMagazines } from 'Webapp/shared/app/redux/selectors/profile';

export default {
  selectors: {
    smartMagazines,
  },
};
